import { GlossaryItem } from '../types';

export const laFamigliaGlossary: GlossaryItem[] = [
  {
    id: 'gl-agitate',
    term: "Agitate",
    definition: "efekt pozwalający poruszyć neutralnych Soldati i wykonać nimi atak.",
    aliases: [],
  },
  {
    id: 'gl-arkusz-akcji',
    term: "Arkusz akcji",
    definition: "dwuczęściowy system pól wpływu i akcji, zmieniany między rundami.",
    aliases: [],
  },
  {
    id: 'gl-bronte',
    term: "Bronte",
    definition: "obszar rozstrzygający remis w podstawowej grze.",
    aliases: [],
  },
  {
    id: 'gl-car',
    term: "Car / samochód",
    definition: "wyposażenie wspierające ruch, atak lub zamach.",
    aliases: ["samochód"],
  },
  {
    id: 'gl-control-tile',
    term: "Control tile / kafel kontroli",
    definition: "drużynowa premia powiązana z kontrolą Mandamento.",
    aliases: ["kafel kontroli"],
  },
  {
    id: 'gl-drug-lab',
    term: "Drug lab / laboratorium",
    definition: "budynek dający dochód i obronę.",
    aliases: ["laboratorium"],
  },
  {
    id: 'gl-faza-planowania',
    term: "Faza planowania",
    definition: "część rundy wykorzystująca wpływy i pola akcji.",
    aliases: [],
  },
  {
    id: 'gl-faza-starcia',
    term: "Faza starcia",
    definition: "część rundy, w której wykonuje się rozkazy.",
    aliases: [],
  },
  {
    id: 'gl-headquarters',
    term: "Headquarters / siedziba",
    definition:
      "Tajny obszar za ekranem gracza: pieniądze, Soldati i niewydane rozkazy. Jawny dla partnera, ukryty przed przeciwną drużyną. To nie zapas.",
    aliases: ["siedziba"],
    sectionId: 'teams-communication',
  },
  {
    id: 'gl-druzyna',
    term: "Drużyna",
    definition:
      "Dwóch partnerów grających wspólnie o zwycięstwo. Każdy prowadzi własną rodzinę; wynik i kafle kontroli Mandamenti są drużynowe.",
    aliases: ["partnerzy"],
    sectionId: 'teams-communication',
    players: [3, 4],
  },
  {
    id: 'gl-influence',
    term: "Influence / wpływ",
    definition:
      "Okrągłe znaczniki na planszy rodziny i arkuszach akcji. Przesuwanie napędza planowanie; zdejmowanie z planszy rodziny odsłania wartości i zaawansowane rozkazy.",
    aliases: ["wpływ"],
  },
  {
    id: 'gl-mandamento',
    term: "Mandamento",
    definition:
      "Region z trzech obszarów o wspólnym kolorze tła. Kolor Mandamento nie jest kolorem gracza. Kontrola wszystkich trzech obszarów daje kafel Mandamento.",
    aliases: [],
  },
  {
    id: 'gl-motorowka',
    term: "Motorówka",
    definition: "element umożliwiający połączenia morskie.",
    aliases: [],
  },
  {
    id: 'gl-pentito',
    term: "Pentito",
    definition: "efekt usuwający własnego zdrajcę i wrogich Soldati.",
    aliases: [],
  },
  {
    id: 'gl-primo-giocatore',
    term: "Primo Giocatore",
    definition: "znacznik pierwszego gracza.",
    aliases: [],
  },
  {
    id: 'gl-soldato',
    term: "Soldato / Soldati",
    definition: "podstawowa jednostka rodziny.",
    aliases: ["Soldati"],
  },
  {
    id: 'gl-strike',
    term: "Strike/Bomb",
    definition: "zamach usuwający jednostki bez przejęcia obszaru.",
    aliases: ["Bomb"],
  },
  {
    id: 'gl-supply',
    term: "Supply / zapas",
    definition: "niewykorzystane elementy rodziny.",
    aliases: ["zapas"],
  },
  {
    id: 'gl-ultima-azione',
    term: "Ultima Azione",
    definition: "specjalne zakończenie fazy planowania po pozostawieniu jednej kolumny.",
    aliases: [],
  },
  {
    id: 'gl-zarzadzanie',
    term: "Zarządzanie",
    definition: "okres aktualizacji kontroli i sprawdzania zwycięstwa.",
    aliases: [],
  },
  {
    id: 'gl-cupola',
    term: "Cupola",
    definition: "Komisja mafijna w wariancie 1 na 1. Liczy się jako Mandamento przy kontroli (próg 11 członków) i zwycięstwie.",
    aliases: ["Kopuła"],
  },
  {
    id: 'gl-komisja',
    term: "Komisja mafijna",
    definition: "Elementy nieużywanej rodziny (wpływy, a w 1 na 1 także Soldati) używane przez gracza samotnego.",
    aliases: ["komisja"],
  },
  {
    id: 'gl-fikcyjna',
    term: "Fikcyjna rodzina",
    definition: "Soldati nieużywanej rodziny na mapie. Bronią obszarów, nie atakują, nie są neutralni i nie podlegają Agitate.",
    aliases: [],
  },
  {
    id: 'gl-gracz-samotny',
    term: "Gracz samotny",
    definition: "Gracz bez partnera w wariancie 1 na 1 lub 2 na 1. Prowadzi jedną rodzinę.",
    aliases: [],
  }
];
